import mapTimeline from './MapTimeline/selectors';
export default {
  mapTimeline: mapTimeline
};